import React, {useEffect, useReducer, useState, useRef} from 'react';

import {reducer} from '@reducers/product/list';

import {useMasterAttribute} from '../Context/MasterAttribute';

function checkedMas(filters) {
	let option = {};
	let options = filters.filter(i => i.type === 'options');

	for (let i = 0; i < options.length; i++) {
		if (option[options[i].masId]) {
			option[options[i].masId][options[i]._id] = true;
		} else {
			option[options[i].masId] = {[options[i]._id]: true};
		}
	}
	return option;
}

function filterOptions(filters) {
	return filters.map(i => {
		let convTitle = {};
		if (i.convensions.length) {
			for (let index = 0; index < i.convensions.length; index++) {
				const el = i.convensions[index];
				convTitle[el._id] = el.title;
				if (el.isBase) {
					i.isBase = el._id.toString();
				}
			}
		}

		i.convTitle = convTitle;
		return i;
	});
}

function getOptions(f) {
	let options = [];
	if (f.type === 'visual') {
		options.push({
			values: f.options.map(i => ({
				label: i.title,
				_id: i.attrVal,
			})),
		});
	} else {
		if (f.convensions.length) {
			const oc = {};
			for (let i = 0; i < f.options.length; i++) {
				const o = f.options[i];
				for (let oi = 0; oi < o.convensions.length; oi++) {
					const el = o.convensions[oi];
					if (oc[el.convension_id]) {
						oc[el.convension_id].values.push({
							_id: o.attrVal,
							label: o.value,
							title: el.value,
						});
					} else {
						oc[el.convension_id] = {
							title: f.convTitle[el.convension_id],
							values: [
								{
									_id: o.attrVal,
									label: o.value,
									title: el.value,
								},
							],
						};
					}
				}
			}

			options = Object.keys(oc).map(i => oc[i]);
		} else {
			options.push({
				values: f.options.map(i => ({
					label: i.value,
					_id: i.attrVal,
				})),
			});
		}
	}

	return options;
}

function checked(state, filter) {
	let status = false;
	if (state || filter) status = true;
	if (!state) status = false;

	return status;
}

function Desktop(props) {
	const {styles} = props;
	const {options, filters, updateFilter} = useMasterAttribute();
	const sliderRef = useRef({});
	const [expanded, setExpanded] = useState({});

	const [state, dispatch] = useReducer(reducer, {
		open: props.retailer ? true : false,
		options: [],
	});

	useEffect(() => {
		dispatch({
			type: 'SET_DATA',
			data: {
				options,
			},
		});
	}, [options]);

	const handelCollapse = _id => {
		if (expanded[_id]) {
			sliderRef.current[_id.toString()].style.height =
				sliderRef.current[_id.toString()].parentElement.clientHeight + 'px';
			setTimeout(() => {
				sliderRef.current[_id.toString()].style.height = '0px';
				setExpanded(val => ({...val, [_id]: !val[_id]}));
			}, 10);
		} else {
			sliderRef.current[_id.toString()].style.height = 'auto';
			setExpanded(val => ({...val, [_id]: !val[_id]}));
		}
	};

	const handleSelect = option => {
		let isExist = filters.find(i => i._id === option._id);
		let newFilter = [];
		if (isExist) {
			newFilter = [...filters.filter(i => i._id !== option._id)];
		} else {
			newFilter = [...filters, {...option, type: 'options'}];
		}

		updateFilter(newFilter, true);
	};

	const checkedAllOption = id => {
		return filters.filter(i => i.masId === id).length ? false : true;
	};

	const checkAllOption = id => {
		let newFilters = [...filters.filter(i => i.masId !== id)];
		updateFilter(newFilters, true);
	};

	const collapseItem = checkedMas(filters);
	return (
		!!state.options.length &&
		filterOptions(state.options).map((filter, index) => (
			<div className={`${styles.filterListCard}`} key={index}>
				<div className={`${styles.cardHeader}`}>
					<span
						className='card-link'
						data-toggle='collapse'
						aria-expanded={checked(
							expanded[filter._id],
							collapseItem[filter._id],
						)}
						onClick={() => handelCollapse(filter._id)}
					>
						{filter.label}
					</span>
				</div>
				<div
					className={`collapse ${
						checked(expanded[filter._id], collapseItem[filter._id]) && 'show'
					}`}
					ref={ref => (sliderRef.current[filter._id.toString()] = ref)}
				>
					<div className={styles.retailerFilter}>
						<div className={styles.checkList}>
							{getOptions(filter).map((item, i) => {
								return (
									<ul key={i}>
										{i === 0 && (
											<li>
												<label className='custom-check'>
													{`All ${filter.label_all}`}
													<input
														type='checkbox'
														checked={checkedAllOption(filter._id)}
														onChange={() => checkAllOption(filter._id)}
													/>
													<span className='checkmark'></span>
												</label>
											</li>
										)}
										{item.title && <li>{item.title}</li>}
										{item.values.map((option, opi) => (
											<li
												key={opi}
												className={`${item.title ? styles.attrConv : ''}`}
											>
												<label className='custom-check'>
													{option.title || option.label}
													<input
														type='checkbox'
														checked={
															collapseItem[filter._id] &&
															collapseItem[filter._id][option._id]
																? true
																: false
														}
														onChange={() =>
															handleSelect({
																_id: option._id,
																label: option.label,
																masId: filter._id,
															})
														}
													/>
													<span className='checkmark'></span>
												</label>
											</li>
										))}
									</ul>
								);
							})}
						</div>
					</div>
				</div>
			</div>
		))
	);
}

function Mobile(props) {
	const {styles} = props;
	const {options, filters} = useMasterAttribute();

	const [state, dispatch] = useReducer(reducer, {
		open: props.retailer ? true : false,
		options: [],
		filters,
		collapseItem: checkedMas(filters),
	});

	useEffect(() => {
		dispatch({
			type: 'SET_DATA',
			data: {
				options,
			},
		});
	}, [options]);

	const handleSelect = (option, all = null) => {
		let collapseItem = {...state.collapseItem};
		let newFilter = [];
		if (all) {
			delete collapseItem[option._id];
			newFilter = [...state.filters.filter(i => i.masId !== option._id)];
			props.setFilter(newFilter);
		} else {
			if (collapseItem[option.masId]) {
				collapseItem[option.masId][option._id] =
					!collapseItem[option.masId][option._id];
			} else {
				collapseItem[option.masId] = {[option._id]: true};
			}
			let isExist = state.filters.find(i => i._id === option._id);

			if (isExist) {
				newFilter = [...state.filters.filter(i => i._id !== option._id)];
			} else {
				newFilter = [...state.filters, {...option, type: 'options'}];
			}

			props.setFilter(newFilter);
		}
		dispatch({
			type: 'SET_DATA',
			data: {
				filters: newFilter,
				collapseItem,
			},
		});
	};

	const checkedAllOption = id => {
		return state.collapseItem[id] ? false : true;
	};

	const collapseItem = {...state.collapseItem};

	return (
		!!state.options.length &&
		filterOptions(state.options).map((filter, index) =>
			props.showLabel ? (
				<li
					key={index}
					className={styles.filterCatgHd}
					onClick={() => props.setFilterType(filter.label, filter._id)}
				>
					{filter.label}
				</li>
			) : (
				props.optionId === filter._id && (
					<div className={`${styles.filterListCard}`} key={index}>
						<div className={`collapse show`}>
							<div className={styles.retailerFilter}>
								<div className={styles.checkList}>
									{getOptions(filter).map((item, i) => {
										return (
											<ul key={i}>
												{i === 0 && (
													<li>
														<label className='custom-check'>
															{`All ${filter.label_all}`}
															<input
																type='checkbox'
																checked={checkedAllOption(filter._id)}
																onChange={() => handleSelect(filter, true)}
															/>
															<span className='checkmark'></span>
														</label>
													</li>
												)}
												{item.title && <li>{item.title}</li>}
												{item.values.map((option, opi) => (
													<li
														key={opi}
														className={`${item.title ? styles.attrConv : ''}`}
													>
														<label className='custom-check'>
															{option.title || option.label}
															<input
																type='checkbox'
																checked={
																	collapseItem[filter._id] &&
																	collapseItem[filter._id][option._id]
																		? true
																		: false
																}
																onChange={() =>
																	handleSelect({
																		_id: option._id,
																		label: option.label,
																		masId: filter._id,
																	})
																}
															/>
															<span className='checkmark'></span>
														</label>
													</li>
												))}
											</ul>
										);
									})}
								</div>
							</div>
						</div>
					</div>
				)
			),
		)
	);
}

function Options(props) {
	return props.isMobile ? <Mobile {...props} /> : <Desktop {...props} />;
}

export default Options;
